import { spawn } from 'redux-saga/effects';

import { sagas as list } from './listModule';

export default function* sagas() {
	yield spawn(list);
}
